import { useMemo } from 'react';
import { useApi } from '../../../providers/ApiProvider'
import AssetSystem from './AssetSystem';
import { useReduxTanStackSync } from '../../../providers/ReduxTanStackSyncProvider';

const useAssetSystem = () => {
	const api = useApi();
	const sync = useReduxTanStackSync();

	return useMemo( () => new AssetSystem( { api, sync } ), [ api, sync ] );
}

export default useAssetSystem;
